import { render, staticRenderFns } from "./mpModule2.vue?vue&type=template&id=119868fe&scoped=true"
import script from "./mpModule2.vue?vue&type=script&lang=js"
export * from "./mpModule2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119868fe",
  null
  
)

export default component.exports